import { useTranslation } from 'react-i18next';
import { AuthLayout } from '@/components/AuthLayout';
import ResetPasswordForm from '@/widgets/ResetPasswordForm';

const ResetPasswordPage = () => {
  const { t } = useTranslation('auth');
  return (
    <AuthLayout title={t('resetPassword')} showHeader>
      <ResetPasswordForm />
    </AuthLayout>
  );
};

export default ResetPasswordPage;
